export const EXPRESSIVE_ICON_VERSION_FOLDER = 'v1';
//# sourceMappingURL=versions.js.map